/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Open_Manager_Aria_LabelInputs */

const en_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open tags manager`)
};

const fr_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le gestionnaire de balises`)
};

const de_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag-Manager öffnen`)
};

const it_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il gestore dei tag`)
};

const ru_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть менеджер тегов`)
};

const es_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir el administrador de etiquetas`)
};

const zh_cn2_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放标签管理器`)
};

const ja_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグマネージャーを開く`)
};

const hi_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग प्रबंधक खोलें`)
};

const pt_pt2_tags_open_manager_aria_label = /** @type {(inputs: Tags_Open_Manager_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra o gerenciador de tags`)
};

/**
* | output |
* | --- |
* | "Open tags manager" |
*
* @param {Tags_Open_Manager_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_open_manager_aria_label = /** @type {((inputs?: Tags_Open_Manager_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Open_Manager_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_open_manager_aria_label(inputs)
	if (locale === "de") return de_tags_open_manager_aria_label(inputs)
	if (locale === "it") return it_tags_open_manager_aria_label(inputs)
	if (locale === "ru") return ru_tags_open_manager_aria_label(inputs)
	if (locale === "es") return es_tags_open_manager_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_open_manager_aria_label(inputs)
	if (locale === "ja") return ja_tags_open_manager_aria_label(inputs)
	if (locale === "hi") return hi_tags_open_manager_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_open_manager_aria_label(inputs)
	return en_tags_open_manager_aria_label(inputs)
});